import { UseQueryOptions, keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { GetStatServiceRoomsDataResponseDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useStatsRoomsListQuery = (
  queryOptions?: Omit<
    UseQueryOptions<AxiosResponse<GetStatServiceRoomsDataResponseDto>>,
    "queryKey"
  >
) => {
  const { statsControllerApi } = useApi();
  return useQuery({
    queryKey: [`/stat-rooms/fetch-rooms-data`],
    queryFn: ({ signal }) => {
      return statsControllerApi.getRoomsData({ rooms: [] }, { signal });
    },
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
};
